import BlurContent from '@/images/client/blur_content.png'
import React from 'react'
import { DoctorMessage } from './DoctorMessage'

interface Props {
  body: string
}

export const BluredDoctorMessage: React.FC<Props> = ({ body }) => {
  const truncateMessage = (message: string) => {
    if (message.length > 30) {
      return message.slice(0, 30) + '...'
    } else {
      return message
    }
  }

  return (
    <div
      className="pc:w-pc-small-inner relative max-w-prose overflow-hidden bg-gray-10 px-4 py-6"
      style={{
        lineHeight: '1.5',
        maxHeight: '200px',
      }}
    >
      <DoctorMessage
        className="pc:w-pc-inner-sm mx-auto"
        body={truncateMessage(body)}
        lineClamp
      >
        <img src={BlurContent} alt="" className="w-full" />
      </DoctorMessage>
      <div className="absolute bottom-0 left-0 right-0 h-32 pointer-events-none bg-gradient-to-b from-transparent to-white backdrop-blur-lg"></div>
    </div>
  )
}
